export type TimeMode = 'viewer' | 'world';

export interface GeoLocation {
  latitude: number;
  longitude: number;
  elevationM: number;
}

export interface WorldConfig {
  location: GeoLocation;
  timeZone: string;
  /** World-local date 'YYYY-MM-DD' — the place's "birth". Set to the first prod deploy date (Task 14). */
  worldEpoch: string;
  /** Earliest date reachable in dev/preview (Open-Meteo archive floor). */
  archiveFloor: string;
  timeMode: TimeMode;
  seed: number;
  cameraAzimuthDeg: number;
  toriiAzimuthDeg: number;
}

export const WORLD: WorldConfig = {
  location: { latitude: 34.409, longitude: 133.205, elevationM: 80 },
  timeZone: 'Asia/Tokyo',
  worldEpoch: '2026-09-27',
  archiveFloor: '1940-01-01',
  timeMode: 'viewer',
  seed: 20260926,
  cameraAzimuthDeg: 258,
  toriiAzimuthDeg: 271,
};
